import { burst, glints, light, rain, shock, type Stage } from '../kit';
import { paper, star, twinkle } from '../shapes';
import { UP, type Preset } from './types';

/**
 * Chess (国际象棋, wave C): the board's own colours — ivory and sage squares falling like flipped tiles, a gold crown
 * of stars over the winning point. Honest play: the page celebrates only a won bank (never a draw, a refund or the
 * bot's training games); one tap skips.
 */
const BOARD = ['#E4DBC7', '#66877B', '#F4ECD6', '#3E5E54', '#FFD166'] as const;

const tiles = (s: Stage, n: number, over: number) =>
  rain(s, {
    n,
    over,
    vy: [80, 160],
    vx: [-20, 20],
    draw: paper,
    cols: BOARD,
    size: [5, 9],
    life: [2, 2.6],
    flip: [3, 6],
    vr: [-2, 2],
    gravity: 40,
  });

export const chess: Preset = {
  pal: BOARD,
  light: '#FFF6E0',
  win(s) {
    burst(s, s.x, s.y, {
      n: 16,
      speed: [110, 260],
      angle: UP,
      spread: Math.PI * 1.5,
      draw: paper,
      cols: BOARD,
      size: [4, 7],
      life: [0.7, 0.95],
      gravity: 280,
      drag: 0.5,
      flip: [4, 8],
    });
    glints(s, s.x, s.y, 6, 24, ['#FFFFFF', '#FFD166']);
  },
  big(s) {
    tiles(s, 120, 1400);
    burst(s, s.x, s.y, {
      n: 24,
      speed: [160, 360],
      angle: UP,
      spread: Math.PI * 1.6,
      draw: star,
      cols: ['#FFD166', '#FFF6E0'],
      size: [5, 8],
      life: [1, 1.3],
      gravity: 260,
      drag: 0.5,
      vr: [-3, 3],
    });
    light(s, s.x, s.y, 110, '#FFD166', 0.7, 0.5);
  },
  mega(s) {
    tiles(s, 200, 2600);
    shock(s.x, s.y, { col: '#FFD166', r: 220, dur: 700 });
    burst(s, s.x, s.y, {
      n: 40,
      speed: [200, 460],
      draw: [star, twinkle],
      cols: ['#FFD166', '#FFFFFF', '#E4DBC7'],
      size: [5, 9],
      life: [1.2, 1.6],
      gravity: 200,
      drag: 0.4,
      vr: [-3, 3],
    });
    light(s, s.x, s.y, 160, '#FFD166', 1, 0.6);
  },
};
